import CF from "./common-functions";
const PHONE = "+7 495 363 32 47"
  .replace(/\s/g, "\u00A0")
  .replace(/-/g, "\u2011");
const PHONE_RAW = PHONE.replace(/\D+/g, "");
let date = CF.getNextDate();

export default {
  offices: [
    {
      address: "Комсомольский проспект д. 28",
      x: 37.580628,
      y: 55.727038,
    },
  ],
  phone: PHONE,
  phone_raw: PHONE_RAW,
  coords: {
    x_center: 37.580628,
    y_center: 55.727038,
  },
  end_date: date,
  need_agreement: true,
  cKeeper: "ctw",
};
